import { ArrowUpRight } from "lucide-react";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="relative overflow-hidden bg-[#1A1A1A] text-[#F8F5EF]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1771033311771-7ec7fa1be3df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxkcm9uZSUyMHNob3QlMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzg1OTY5NDh8MA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A] via-[#1A1A1A]/85 to-transparent"></div>
      </div>
      <div className="relative container-x py-24 md:py-36 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-8 reveal">
          <div className="flex items-center gap-3 mb-6">
            
            <span className="overline text-[#FFA500]">Bereit?</span>
          </div>
          <h3 className="font-display text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
            Lassen Sie Ihre Immobilie <br />
            <span className="gold-text italic">verkaufsstark</span> präsentieren.
          </h3>
        </div>
        <div className="md:col-span-4 md:justify-self-end reveal">
          <a
            href="#kontakt"
            data-testid="cta-band-button"
            className="group inline-flex items-center justify-between px-8 py-4 bg-[#FFA500] text-[#1A1A1A] text-xs uppercase tracking-[0.2em] hover:bg-[#F8F5EF] transition-colors duration-300 min-w-[280px] font-medium"
          >
            Kostenloses Erstgespräch
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </div>
    </section>
  );
}
